import { t } from "@/i18n-js/instance";
import { LineItem } from "./LineItem";

const localeRoot = "pricing_plans.plan_settings.plan_summary";

interface DiscountCouponProps {
  discountCoupon: string;
}

export const DiscountCoupon = ({ discountCoupon }: DiscountCouponProps) => (
  <LineItem
    description={t([localeRoot, "discount_coupon"])}
    value={discountCoupon}
    valueProps={{ color: "text-green-success" }}
  />
);
